// extracted by css-extract-rspack-plugin
export default {"button":"InsightsButton-module__button___zjRUN"};